import { xenvActionFactory } from '../xenv';
import { 
// alimpSubscribe,
// alipaySubscribe,
// bdmpSubscribe,
// cappSubscribe,
cowxmpSubscribe, cxwxmpSubscribe, 
// driverSubscribe,
drwxmpSubscribe, gjwxmpSubscribe, 
// h5Subscribe,
// kfalimpSubscribe,
// kfdriverSubscribe,
kfdwxmpSubscribe, 
// kfpassengerSubscribe,
kfwxmpSubscribe, 
// mqqSubscribe,
// passengerSubscribe,
qjwxmpSubscribe, 
// qqmpSubscribe,
thwxmpSubscribe, 
// weixinSubscribe,
wxmpSubscribe, yxwxmpSubscribe, sfcwxmpSubscribe, hywxmpSubscribe } from '../platform/xenv';
const xenvSubscribeConfig = {
    // 'alimp': alimpSubscribe, 
    // 'alipay': alipaySubscribe,
    // 'bdmp': bdmpSubscribe,
    // 'capp': cappSubscribe,
    'cowxmp': cowxmpSubscribe,
    'cxwxmp': cxwxmpSubscribe,
    'sfcwxmp': sfcwxmpSubscribe,
    // 'driver': driverSubscribe,
    'drwxmp': drwxmpSubscribe,
    'gjwxmp': gjwxmpSubscribe,
    // 'h5': h5Subscribe,
    // 'kfalimp': kfalimpSubscribe,
    // 'kfdriver': kfdriverSubscribe,
    'kfdwxmp': kfdwxmpSubscribe,
    // 'kfpassenger': kfpassengerSubscribe,
    'kfwxmp': kfwxmpSubscribe,
    // 'mqq': mqqSubscribe,
    // 'passenger': passengerSubscribe,
    'qjwxmp': qjwxmpSubscribe,
    // 'qqmp': qqmpSubscribe,
    'thwxmp': thwxmpSubscribe,
    // 'weixin': weixinSubscribe,
    'wxmp': wxmpSubscribe,
    'yxwxmp': yxwxmpSubscribe,
    'hywxmp': hywxmpSubscribe
};
export const subscribe = (option) => {
    const fn = xenvActionFactory('subscribe', xenvSubscribeConfig);
    return fn(option);
};
